/**
 * 指定の文字列から ID 部分を抽出する関数
 * @param input - "<種別の文字列>|<ID>" 形式の文字列
 * @returns ID 部分の文字列（入力形式が不正な場合は null を返す）
 */
export const ExtractId = (input: string): string | null => {
  if (!input) {
    return ""
  }
  if (!input.includes("|")) {
    return ""
  }

  const parts = input.split("|")
  return parts.length === 2 ? parts[1] : null // 正常な形式なら ID 部分を返す
}
